import { useAtom } from 'jotai';
import { completedAtom } from '@/store';

export const useCompleted = () => useAtom(completedAtom);
